/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface ContentStoreAPI
 * @hideconstructor
 * @classdesc API class that is used to communicate with the content store.
 * @example appFactory.getFeature('ContentStore')
 */
define([], () => {
	class ContentStoreAPI {

		/**
		 * @function ContentStoreAPI#get
		 * @description Returns the content from a specified location.
		 * @param {id} id - ID of the location, defaults to 'My content'.
		 * @return {Promise<Object[]>} Promise resolved with an array of store content {id, type, defaultName, modificationTime, owner}; rejected with status code on error.
		 */
		get() { }

		/**
		 * @function ContentStoreAPI#post
		 * @description Posts content to a location.
		 * @param {id} id - ID of the location
		 * @param {Object} content - Content to post
		 * @return {Promise} Promise resolved on success; rejected with status code on error.
     * @example contentStore.post('i641E742AA0784BEF87829388BB7FCE2E', { type: 'folder', defaultName: 'myFolder' })
		 */
		post() { }

		/**
		 * @function ContentStoreAPI#put
		 * @description Puts content at a location.
		 * @param {id} id - ID of the location
		 * @param {Object} content - Content to put
		 * @return {Promise} Promise resolved on success, rejected with status code on error.
		 * @example contentStore.put('i641E742AA0784BEF87829388BB7FCE2E', {parent: [{id: "i4BFD414719954E348FA4582E750450FE"}]}) // moves the asset
		 * @example contentStore.put('i641E742AA0784BEF87829388BB7FCE2E', {type: 'exploration', defaultName: 'myNewName'}) // renames the asset
		 */
		put() { }

		/**
		 * @function ContentStoreAPI#delete
		 * @description Deletes content a content.
		 * @param {id} id - ID of the content
		 * @return {Promise} Promise resolved on success; rejected with status code on error.
		 */
		delete() { }
	}
	return ContentStoreAPI;
});
